































import { Component, Vue } from "vue-property-decorator";
import { apiMarginLog } from "../../service";
import { LogColumns } from "../../config";
@Component({})
export default class Svip extends Vue {
  public visible = false;
  public loading = false;
  public form = {
    id: "",
  };
  public orderNum = "";
  public data: any = {};
  public pageSize = {
    size: 10,
    page: 1,
  };
  public columns = LogColumns;
  public show(uid, num) {
    this.data = {};
    this.pageSize = {
      size: 10,
      page: 1,
    };
    this.form.id = uid;
    this.orderNum = num;
    this.init();
    this.visible = true;
  }
  public async init() {
    this.loading = true;
    const res = await apiMarginLog({
      ...this.pageSize,
      ...this.form,
    });
    if (res.code === 0) {
      this.data = res.data;
    }
    this.loading = false;
  }
  public pageChange(index) {
    this.pageSize.page = index;
    this.init();
  }
}
